export default __webpack_public_path__ + "static/media/AccraGhana.9d7b13fd.jpg";